import React, { createContext, useContext, useState } from 'react';
import { UseSystemAlertOptions } from '@/hooks/useSystemAlert';

const defaultAlertOptions: UseSystemAlertOptions = {
  description: '',
  title: '',
  dependencies: [],
  condition: () => false,
};

export interface SystemAlertContextType {
  isSystemAlertActive: boolean;
  setIsSystemAlertActive: React.Dispatch<React.SetStateAction<boolean>>;
  contextSystemAlertOptions: UseSystemAlertOptions;
  setContextSystemAlertOptions: React.Dispatch<React.SetStateAction<UseSystemAlertOptions>>;
}

const SystemAlertContext = createContext<SystemAlertContextType | undefined>(undefined);

function SystemAlertProvider({ children }: { children: React.ReactNode }) {
  const [isSystemAlertActive, setIsSystemAlertActive] = useState(false);
  const [contextSystemAlertOptions, setContextSystemAlertOptions] = useState(defaultAlertOptions);

  return (
    <SystemAlertContext.Provider
      value={{
        isSystemAlertActive,
        setIsSystemAlertActive,
        contextSystemAlertOptions,
        setContextSystemAlertOptions,
      }}
    >
      {children}
    </SystemAlertContext.Provider>
  );
}

function useNotificationAlertContext() {
  const context = useContext(SystemAlertContext);

  if (context === undefined) {
    throw new Error('Incorrect use of Context');
  }

  return context;
}

export { SystemAlertProvider, useNotificationAlertContext, SystemAlertContext };
